import { render } from "./reportsPage.vue?vue&type=template&id=0ecef46a&scoped=true"
import script from "./reportsPage.vue?vue&type=script&lang=js"
export * from "./reportsPage.vue?vue&type=script&lang=js"

import "./reportsPage.vue?vue&type=style&index=0&id=0ecef46a&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecef46a"]])

export default __exports__